/**
 * /dashboard/settings — Settings hub landing.
 *
 * Auto-redirects to the first reachable leaf for the caller's role
 * (SOP §4.2). Routed in the client because /me's role isn't known on
 * the SSR/loader path; the redirect is computed in render via
 * useNavigate() after the auth context resolves.
 *
 * Migration note (2026-06-01, Next.js → Vite Phase 3g): direct port
 * of frontend/src/app/(dashboard)/dashboard/settings/page.tsx. The
 * Next.js `useRouter().replace()` becomes TanStack Router's
 * `useNavigate({ replace: true })`.
 */

import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { firstReachableSettingsLeaf } from "@/lib/settings-nav";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/")({
  component: SettingsLandingRoute,
});

function SettingsLandingRoute() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    void navigate({
      to: firstReachableSettingsLeaf(user?.role),
      replace: true,
    });
  }, [loading, user?.role, navigate]);

  return (
    <div className="flex items-center justify-center py-16">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
